import type { ImpactOffice } from '../types/campaign'

/** [Canvasser redesign Phase 8] Pure formatting for the impact card + organizer editor. */
export const OFFICE_LABEL: Record<ImpactOffice, string> = {
  President: 'President',
  USSenate: 'US Senate',
  Governor: 'Governor',
}

const RACE_LABEL: Record<ImpactOffice, string> = {
  President: 'presidential race',
  USSenate: 'US Senate race',
  Governor: "governor's race",
}

export function raceLabel(office: string): string {
  return RACE_LABEL[office as ImpactOffice] ?? 'race'
}

export function formatVotes(n: number): string {
  return n.toLocaleString('en-US')
}

/** Below the rate: a countdown to the first extra vote (encouraging, never "≈ 0"). At/above: rounded. */
export function votesLine(conversations: number, perVote: number, who: 'you' | 'team'): string {
  if (conversations < perVote) {
    const left = perVote - conversations
    const whose = who === 'you' ? 'your' : "the team's"
    return `${left} more conversation${left === 1 ? '' : 's'} to ${whose} first extra vote`
  }
  const votes = Math.round(conversations / perVote)
  return `≈ ${votes} extra vote${votes === 1 ? '' : 's'}`
}

export function reachPercent(people: number, universe: number): number | null {
  if (universe <= 0) return null
  return Math.min(100, Math.round((people * 100) / universe))
}

export function contestKey(office: ImpactOffice, year: number): string {
  return `${office}:${year}`
}

export function parseContestKey(key: string): { office: ImpactOffice; year: number } | null {
  const [office, year] = key.split(':')
  if (!office || !year) return null
  return { office: office as ImpactOffice, year: Number(year) }
}
